var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"cross","transform":"translate(-1379.000000, -40.000000)","fill":"#003A1B","fillRule":"nonzero"},React.createElement("g",{"id":"icons8-delete_sign_filled","transform":"translate(1379.000000, 40.000000)"},React.createElement("polygon",{"id":"Path","points":"1.74424342 0.172697368 0.172697368 1.74424342 8.92845395 10.5 0.120888158 19.3248355 1.67516447 20.8791118 10.5 12.0715461 19.3075658 20.8791118 20.8791118 19.3075658 12.0715461 10.5 20.8273026 1.74424342 19.2557566 0.172697368 10.5 8.92845395"})))));
}

Cross.defaultProps = {"width":"21px","height":"21px","viewBox":"0 0 21 21","version":"1.1"};

module.exports = Cross;

Cross.default = Cross;
